@if (showSelect()) {
  <label class="sr-only" [for]="id">{{ { key: 'quantity' } | i18n }}</label>
  <select
    [id]="id"
    name="quantity-select"
    class="w-16 rounded-md border border-gray-300 py-1.5 text-left text-base font-medium leading-5 text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 sm:text-sm p-2"
    [ngModel]="value | async"
    (ngModelChange)="changeValue($event)"
  >
    @for (option of selectOptions(); track option.value) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>
} @else {
  <input
    name="quantity"
    type="number"
    [ngModel]="value | async"
    (ngModelChange)="changeValue($event)"
    placeholder="{{ { key: 'quantity' } | i18n }}"
    (blur)="onBlur()"
    [min]="1"
    [max]="availableQuantity()"
    class="w-16 rounded-md border border-gray-300 py-1.5 text-left text-base font-medium leading-5 text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 sm:text-sm p-2"
  />
}
